import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";

export default function BookingSuccess() {
  const [params] = useSearchParams();
  const ref = params.get("ref");
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    if (!sessionId) return;
    let attempts = 0;
    const poll = async () => {
      if (attempts++ >= 8) { setStatus("timeout"); return; }
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") { setStatus("paid"); try { localStorage.removeItem("de_resume"); } catch (e) { console.debug("Could not clear resume cache:", e); } return; }
        if (r.data.status === "expired") { setStatus("expired"); return; }
      } catch (e) { console.debug("Payment status poll failed (will retry):", e); }
      setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId]);

  return (
    <main data-testid="booking-success-page" className="px-6 md:px-12 lg:px-16 pt-16 pb-24 max-w-3xl">
      <div className="label-eyebrow mb-6">Booking</div>
      {status === "paid" && <>
        <h1 className="font-black tracking-tighter leading-[0.95] text-5xl md:text-6xl">Deposit received. Slot locked.</h1>
        <p className="mt-8 text-[#6B7280] leading-relaxed text-lg">We've sent your booking confirmation, payment schedule and Client Portal access details to your email.</p>
      </>}
      {status === "checking" && <h1 className="font-black tracking-tighter leading-[0.95] text-5xl md:text-6xl">Verifying payment…</h1>}
      {(status === "timeout" || status === "expired") && <h1 className="font-black tracking-tighter leading-[0.95] text-5xl md:text-6xl">We're checking…</h1>}

      <div className="de-card p-8 mt-12">
        <div className="label-eyebrow mb-3">Your reference</div>
        <div className="text-3xl font-bold tracking-tight" data-testid="booking-ref">{ref || "—"}</div>
        <div className="de-hr my-6"/>
        <div className="text-sm text-[#6B7280]">Use this reference plus your email address to access the Client Portal.</div>
        <Link to="/portal" className="de-btn-primary mt-6">Open Client Portal</Link>
      </div>
    </main>
  );
}
